<template src="./assetchecks.html"></template>
<script>
import VueGallery from "vue-gallery";
import Multiselect from "vue-multiselect";
import Axios from "axios";
import $ from "jquery";
var moment = require("moment");

export default {
  components: {
    VueGallery,
    Multiselect,
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
  },
  data() {
    return {
      basic: {
        currentPage: 1,
        totalPages: 0,
        type: "",
      },

      AssetImageEndpoint: Endpoints.Vehicle.Image + "/",
      ImageEndpoint: Endpoints.Helper.Image + "/",
      ShowLoader: false,
      AssetCheckDuration: false,
      ShowDownloadLoader: false,
      SearchKey: "",
      fromDate: "",
      toDate: "",
      name: "",
      driver: "",
      CompanyChecksSelected: [],
      StatusSelected: [],
      AssetChecksSubmit: [],
      AssetChecks: [],
      Status: ["Pass", "Warning", "Fail"],
      AssetNotes: "",
      ShowAssetCheckImageModel: false,
      ShowAssetNotesModel: false,
      ShowAssetNotesModelHeading: "Notes",
      excel_data: [],
      lightgallery: [],
      biglightgallery: [],
      gindex: 1,
      galleryoptions: {
        prevClass: "prev",
        nextClass: "next",
        startSlideshow: false,
      },
      asset_template_id: 0,
      AssetTemplate: "",
      FleetSubscription: [],
      ActivityPage: 1,
      LastPageRequest: 0,
      showLocationDetails: false,
      infoOpened: false,
      locationPoints: "",
      center: {
        lat: 55.232753,
        lng: -3.944403,
      },
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
        content: "",
      },
    };
  },
  watch: {
    "$route.query": {
      handler: function () {
        this.asset_template_id = this.$route.params.AssetTemplateID;
        this.ActivityPage = 1;
        this.LastPageRequest = 0;
        this.basic.currentPage = 1;
        this.fromDate = "";
        this.toDate = "";
        this.AssetChecks = [];
        this.GetAssetChecksList();
      },
      deep: true,
    },
  },
  mounted() {
    var AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
    );
    this.FleetSubscription = JSON.parse(
      localStorage.getItem("FleetSubscription")
    );
    var FleetSubscriptionModules = JSON.parse(
      this.FleetSubscription.fleet_modules
    );
    if(!FleetSubscriptionModules.Assets && (!AccountPermissions.Assets || !AccountPermissions.Assets.enable)){
		  this.$router.push('/');
		}

    document.title = pbx_SiteTitle + " - Assets Checks";
    this.asset_template_id = this.$route.params.AssetTemplateID;
    this.ActivityPage = 1;
    this.LastPageRequest = 0;
    this.AssetChecks = [];
    this.GetAssetChecksList();

    var CompanySettingsKey = JSON.parse(localStorage.getItem("Company") );
    if(CompanySettingsKey.fleet_settings_key != "undefined"){
      CompanySettingsKey = JSON.parse(CompanySettingsKey.fleet_settings_key);
      if (CompanySettingsKey != null && typeof CompanySettingsKey.AssetCheckDuration != "undefined" && CompanySettingsKey.AssetCheckDuration) {
        this.AssetCheckDuration = CompanySettingsKey.AssetCheckDuration;
      }
    }

  },

  methods: {
    ShowLocationMap(CheckDetails) {
      this.showLocationDetails = true;
      const marker = {
        lat: parseFloat(CheckDetails.latitude),
        lng: parseFloat(CheckDetails.longitude),
      };
      this.center = marker,
      this.locationPoints = marker;
      this.infoOpened = true;
      this.infoOptions.content =
        '<div id="mapcontent"><h5 id="firstHeading" class="firstHeading" style="margin: 0px;">' +
          CheckDetails.asset.name +
        "</h5></div>";
    },
    SearchAssetChecks(type) {
      this.ActivityPage = 1;
      this.LastPageRequest = 0;
      this.AssetChecks = [];
      this.GetAssetChecksList(type);
    },
    GetAssetChecksList(type = "") {
      if (
        (this.ActivityPage > 0 && this.LastPageRequest != this.ActivityPage) ||
        type == "download"
      ) {
        this.LastPageRequest = this.ActivityPage;
        var obj = {
          token: localStorage.getItem("token"),
          paginate: true,
          page: this.ActivityPage,
        };
        if (type == "search" || type == "download") {
          obj.name = this.name;
          obj.fromDate = this.fromDate;
          obj.toDate = this.toDate;
          obj.driver = this.driver;
          obj.companychecksselected = this.CompanyChecksSelected;
          obj.statusselected = this.StatusSelected;
        }
        if (type == "download") {
          delete obj.paginate;
          delete obj.page;
          this.ShowDownloadLoader = true;
        } else {
          this.ShowLoader = true;
        }
        obj.asset_template_id = this.asset_template_id;

        Axios.post(Endpoints.Assets.Checks.List, obj).then(
          (Response) => {
            if (Response.data.success) {
              this.ShowLoader = false;
              this.ShowDownloadLoader = false;
              if (type == "download") {
                this.SetAssetChecksExcelData(Response.data.FleetCheckSubmit);
              } else {
                if (this.ActivityPage == 1) {
                  this.basic.totalPages = Response.data.totalPage;
                  this.basic.type = type;
                }
                this.AssetChecksSubmit = Response.data.FleetCheckSubmit;
                this.AssetChecks = Response.data.AssetChecks;
                
                if(Response.data.AssetTemplate){
                  this.AssetTemplate = Response.data.AssetTemplate.subcategory_name;
                }else{
                  this.$router.push('/');
                }
                
              }
            }
          }
        );
      }
    },
    SetAssetChecksExcelData(AssetChecks) {
      this.excel_data = [];
      AssetChecks.forEach((element) => {
        var obj = {};
        obj["created_at"] = element.created_at;
        obj["name"] = element.asset.name;
        obj["driver"] = element.driver.forename + " " + element.driver.surname;
        this.AssetChecks.forEach((CompanyElement) => {
          obj[CompanyElement.name] = "";
          element.value.forEach((ValueElement) => {
            if (ValueElement.asset_check_id == CompanyElement.id) {
              if (ValueElement.value == 1 && ValueElement.warning != 1) {
                obj[CompanyElement.name] = "Pass";
              }
              if (ValueElement.value == 1 && ValueElement.warning == 1) {
                obj[CompanyElement.name] = "Warning";
              }
              if (ValueElement.value == 2) {
                obj[CompanyElement.name] = "Fail";
              }
            }
          });
        });

        if (element.safe == 1) obj["safe"] = "Safe";
        else obj["safe"] = "UnSafe";

        obj["current_miles"] = element.current_miles;
        obj["current_hours"] = element.current_hours;
        obj["notes"] = element.notes;

        this.excel_data.push(obj);
      });

      setTimeout(function () {
        document.getElementById("downloadexcel").click();
      }, 1000);
    },
    ShowAssetNotes(AssetCheck, type = "notes") {
      if (AssetCheck.notes != null && AssetCheck.notes != "") {
        this.ShowAssetNotesModel = true;
        this.AssetNotes = AssetCheck.notes;
        this.ShowAssetNotesModelHeading = "Notes";
      }
    },
    ShowAssetCheckImage(AssetCheck) {
      this.ShowAssetCheckImageModel = true;
      this.biglightgallery = JSON.parse(AssetCheck.photo);
      for (var i = 0; i < this.biglightgallery.length; i++) {
        this.biglightgallery[i] = this.ImageEndpoint + this.biglightgallery[i];
      }
    },
    ShowAssetImage(AssetCheck) {
      this.ShowAssetCheckImageModel = true;
      this.lightgallery = JSON.parse(JSON.stringify(AssetCheck.photo));
      this.biglightgallery = JSON.parse(JSON.stringify(AssetCheck.photo));
      for (var i = 0; i < this.biglightgallery.length; i++) {
        this.biglightgallery[i] = this.ImageEndpoint + this.biglightgallery[i];
      }
    },
    pagechanged() {
      if (
        this.ActivityPage > 0 &&
        this.LastPageRequest != this.basic.currentPage
      ) {
        this.ActivityPage = this.basic.currentPage;
        this.GetAssetChecksList(this.basic.type);
      }
    },
  },
};
</script>
<style scoped>
.assetchecklist th:first-child,
  .assetchecklist th:nth-child(2) {
    background: #fff !important;
  }
  .assetchecklist th:first-child{
    min-width: 119px;
  }
  .assetchecklist th:first-child,
  .assetchecklist td:first-child,
  .assetchecklist th:nth-child(2),
  .assetchecklist td:nth-child(2),
  .assetchecklist th:nth-child(3),
  .assetchecklist td:nth-child(3) {
    position: sticky;
    left: -1px;
    background: #fff !important;
    z-index: 5;
  }
 .assetchecklist td:first-child,
 .assetchecklist td:nth-child(2),
  .assetchecklist td:nth-child(3) {
    position: sticky;
    left: -1px;
    background: #fff !important;
    z-index: 2;
  }
  .assetchecklist th:nth-child(2),
  .assetchecklist td:nth-child(2) {
    left: 119px;
    width: 110px !important;
  }
  .assetchecklist th:nth-child(3),
  .assetchecklist td:nth-child(3) {
    left: 253px;
    min-width: 150px !important;
  }
  .custom-scrollbar2 thead th {
    position: sticky;
    top: -1px;
    background: #FFF;
    z-index: 4;
}
.asset_name{
  display: flex;
  max-width: 120px !important;
}
.asset_name span {
    width: 110px !important;
    font-weight: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
}
  .datatable-vue table tbody tr:nth-child(odd) td {
    background-color: #f9f9f9 !important;
  }
  .datatable-vue table tbody tr:hover td {
    background-color: #f9f9f9 !important;
  }
</style>
<style type="text/css">
td .text-primary {
  color: #8f4f88 !important;
}
.assetchecklist .btn {
  padding: 0.375rem 1.25rem;
}
.assetchecklist td.w120 {
  width: 120px !important;
  min-width: 120px !important;
}
.assetchecklist td.w100 {
  width: 100px !important;
  min-width: 100px !important;
}
.assetchecklist td.w80 {
  width: 80px !important;
  min-width: 80px !important;
}
span.failicon {
  position: relative;
}
td.CompanyChecks .fixedbage {
  position: absolute;
  z-index: 1;
}
td.CompanyChecks {
  position: relative;
}
td.CompanyChecks span.btn {
  padding: 3px 8px;
}
td.CompanyChecks .dropdown .dropdown-toggle {
  padding: 0.375rem 1.75rem;
}
td.CompanyChecks .dropdown {
  margin-bottom: 0px !important;
}
.nosubmenu .dropdown-toggle::after {
  display: none;
}
.dropdown-basic .dropdown .dropdown-menu {
  z-index: 99 !important;
}
.AssetCheckPaging .page-item:last-child .page-link,
.AssetCheckPaging .page-item:first-child .page-link {
  padding: 6px 6px 5px 6px;
}
.ChecksFilter .multiselect__content-wrapper {
  z-index: 1000;
}
@media screen and (max-width: 990px) {
  .search-data {
    width: 30%;
  }
  .d-flex.label-box {
    display: block !important;
    width: 100% !important;
  }

  .label-box span {
    width: 100% !important;
  }
  .searchregs {
    margin: 10px 0;
  }
}
@media screen and (max-width: 780px) {
  .search-data {
    width: 100%;
  }
}
@media (min-width: 762px) and (max-width: 1180px) {
  .asset-checks .col-xl-3,
  .asset-checks .col-xl-2 {
    max-width: 25%;
  }
  .asset-checks .col-xl-3 .searchregs {
    margin-top: 17px;
  }
  .search-data {
    margin-top: 17px;
    min-width: 100%;
  }
}
@media (min-width: 1180px) and (max-width: 1379px) {
  .asset-checks .col-xl-3,
  .asset-checks .col-xl-2 {
    max-width: 25%;
  }
  .asset-checks .col-xl-3 .searchregs {
    margin-top: 0;
  }
  .search-data {
    margin-top: 0;
    min-width: 100%;
  }
}
.textupper {
  text-transform: uppercase !important;
}
.map-modal-body {
  max-width: 1200px !important;
}
</style>
